import { render, staticRenderFns } from "./promises.vue?vue&type=template&id=4d3977e1&"
import script from "./promises.vue?vue&type=script&lang=js&"
export * from "./promises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports